import { render, staticRenderFns } from "./EditSops.vue?vue&type=template&id=0f714888&scoped=true&"
import script from "./EditSops.vue?vue&type=script&lang=js&"
export * from "./EditSops.vue?vue&type=script&lang=js&"
import style0 from "./EditSops.vue?vue&type=style&index=0&id=0f714888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f714888",
  null
  
)

export default component.exports